import React from 'react'
import { observer } from 'mobx-react-lite'

import { BtScreen } from '@linqpal/components/src/ui'

type ProjectWrapperProps = {
  header?: React.ReactNode
  sidebar?: React.ReactNode
  modal?: React.ReactNode
  children?: React.ReactNode
}

export const ProjectsWrapper = observer(
  ({ modal, sidebar, children, header }: ProjectWrapperProps): JSX.Element => {
    return (
      <BtScreen
        header={header}
        children={
          <>
            {modal}
            {sidebar}
            {children}
          </>
        }
      />
    )
  },
)
